import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { LiaGripLinesSolid } from "react-icons/lia";
import { AiOutlineClose } from "react-icons/ai";
import { motion, AnimatePresence } from 'framer-motion';
import './header.scss';

const Header = () => {
    const [isOpen, setIsOpen] = useState(false);
    const MotionLink = motion(Link);
  return (
    <nav>
      <div className="nav-container">
        <Link to="/" className="logo">
          <img 
            src="https://res.cloudinary.com/dsnontai6/image/upload/v1769972096/agc1_pphjp6_f8d7eb.png" 
            alt="Church Logo" 
          />
        </Link>
        <ul className="nav-links">
          <li><Link to="/">Home</Link></li>
          <li><Link to="/connect">Connect</Link></li>
          <li><Link to="/give" className="nav-cta">Give</Link></li>
        </ul>

        {/* mobile */}
        <div className="mobile-toggle" onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? <AiOutlineClose className="mobile-toggle_icon" /> : <LiaGripLinesSolid className="mobile-toggle_icon" />}
        </div>

        {/* Mobile dropdown menu */}
        <AnimatePresence>
        {isOpen && (
          <>
          <div className="navbar__dropdown-overlay" onClick={() => setIsOpen(false)} />
          <div className="navbar__dropdown">
            <MotionLink initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1, duration: 0.4 }} to="/" className="navbar__dropdown-link" style={{ animationDelay: '0.1s' }}>Home</MotionLink>
            <MotionLink initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2, duration: 0.4 }} to="/connect" className="navbar__dropdown-link" style={{ animationDelay: '0.2s' }}>Connect</MotionLink>
            <MotionLink initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3, duration: 0.4 }} to="/give" className="navbar__dropdown-btn" style={{ animationDelay: '0.3s' }}>Give</MotionLink>
          </div>
          </>
        )}
        </AnimatePresence>
      </div>
    </nav>
  );
};

export default Header;
